import { Currency } from '@/core/currency/interfaces';

const NIO: Currency = {
    name: 'Nicaraguan Córdoba',
    demonym: 'Nicaraguan',
    majorSingle: 'Córdoba Oro',
    majorPlural: 'Córdoba Oro',
    codeNumeric: '558',
    symbol: 'C$',
    symbolNative: 'C$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'NIO',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default NIO;
